import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const OptionsWrapper = styled('div')`
  display: flex;
  align-items: center;

  &:last-child {
    padding-right: 0px !important;
  }
`

export const ButtonCustom = styled(Button)`
  @media (min-width: 1024px) {
    padding: ${({ lastButton }) => (lastButton ? '0px 0px 0px 13px' : '0 13px')};
  }
`

export const CustomButtonMenu = styled.button`
  background: white;
  outline: none;
  border: none;
`

export const Divider = styled.div`
  width: 48px;
  height: 4px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.grey24};
`

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const MenuOptsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  margin: 18px 0px 0px 12px;
  gap: 24px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`

export const CorazonContainer = styled.div`
  padding: 0 13px;
  @media (min-width: 1024px) {
    padding: 0px 0px 0px 13px;
  }
`

export const ButtonPostularme = styled(Button)`
  min-width: 168px;
  opacity: ${({ showAnchorPostular }) => (showAnchorPostular ? 1 : 0)};
  transition: all 0.5s ease-in-out;

  ${({ productoLookAndFeel }) =>
    productoLookAndFeel
      ? `background-color: ${productoLookAndFeel?.colorBackgroundBotones} !important;
      border-color:${productoLookAndFeel?.colorBordeCaja} !important;`
      : ``}
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  gap: 8px;
`
